import { Button } from '@hub/button';
import { SearchMediumIcon } from '@hub/icon';
import React from 'react';
import { useHeaderProps } from './header';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderSearchButton = () => {
  const {
    onClickSearch: onClick
  } = useHeaderProps();
  return /*#__PURE__*/_jsx(Button, {
    variant: "searchBar",
    colorScheme: "smoke",
    size: "icon-lg",
    width: "size-full",
    maxWidth: [null, null, '440px'],
    leftIcon: /*#__PURE__*/_jsx(SearchMediumIcon, {
      boxSize: "size-icon-sm",
      "data-id": "header_header-search-button_HeaderSearchButton_SearchMediumIcon"
    }),
    onClick: onClick,
    "data-id": "header_header-search-button_HeaderSearchButton_Button",
    children: "Search all of Westfield"
  });
};